import { CreateAccountDocument } from '@graphql/generated/graphql';

import { useInitializeSession } from '@services/AuthService/useInitializeSession';

import { useMutation, useReactiveVar } from '@apollo/client';
import { sessionProcessingVar } from '@boot/reactiveVariables';

export const useSignUp = () => {
    const [createAccount, { error, reset }] = useMutation(
        CreateAccountDocument,
        {
            context: {
                notifyOnError: true,
            },
            onError: () => {},
        },
    );
    const { initializeSession } = useInitializeSession(createAccount, true);
    const signUpProcessing = useReactiveVar(sessionProcessingVar);

    return {
        cancelSignUp: reset,
        handleSignUp: initializeSession,
        signUpError: error,
        signUpProcessing,
    };
};
